export const subjects = [
  { name: 'C-Programming (C-Prog)', value: 'C-Prog' },
  { name: 'Compiler Design (CD)', value: 'CD' },
  { name: 'Computer Network (CN)', value: 'CN' },
  { name: 'Computer Organization And Architecture (COA)', value: 'COA' },
  { name: 'Data Structure And Algorithms (DSA)', value: 'DSA' },
  { name: 'Database Management System (DBMS)', value: 'DBMS' },
  { name: 'Digital Logic (DL)', value: 'DL' },
  { name: 'Discrete Mathematics (DM)', value: 'DM' },
  { name: 'General Aptitude (GA)', value: 'GA' },
  { name: 'Mathematics (MATHs)', value: 'MATHS' },
  { name: 'Operating System (OS)', value: 'OS' },
  { name: 'Theory of Computation (TOC)', value: 'TOC' },
];
